import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { Link } from 'react-router-dom';
import { SimpleButton } from '../styles';
import { Profile } from '~/helpers/userProfile';
import { TableDuts } from '../Tables/TableDuts';
import { TableRoomTypes } from '../Tables/TableRoomTypes';
import { ApiResps } from '~/providers';
import { DutsExtraInfo, EnvironmentList } from '../ClientPanel';

export type EnvironmentsPanelProps = {
  state: {
    roomTypes: ApiResps['/clients/get-roomtypes-list']['rtypes'] & ({
      DUTS_COUNT?: number
      DRIS_COUNT?: number
      schedCol?: string
    })[];
    dutsList: ApiResps['/dut/get-duts-list']['list'] & (DutsExtraInfo[]);
    vavsList: ApiResps['/dri/get-dri-vavs-list']['list'];
    environmentList: EnvironmentList[];
  };
  profile: Profile;
  fetchEnvironmentsData: () => void;
  setState: (state: { isLoading: boolean }) => void;
  deleteEnvironment: (item: EnvironmentList) => Promise<void>;
  openEditDut: (unit: any, itemToEdit: any) => void;
  deleteRoomType: (item: any) => Promise<void>;
  openCreateEditRoomType: () => void;
  clientId: number;
}

export const EnvironmentsPanel = ({
  state,
  profile,
  fetchEnvironmentsData,
  setState,
  deleteEnvironment,
  openEditDut,
  deleteRoomType,
  openCreateEditRoomType,
  clientId,
}: EnvironmentsPanelProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(t('ambientes'));

  function tableEnvironments() {
    if (state.dutsList.length === 0 && state.vavsList.length === 0) {
      return <div>{`(${t('nenhum')})`}</div>;
    }

    return (
      <TableDuts
        list={state.environmentList}
        vavsList={state.vavsList}
        onEditClick={openEditDut}
        onDeleteClick={deleteEnvironment}
        roomTypes={state.roomTypes.map((item) => ({ value: item.RTYPE_ID, name: item.RTYPE_NAME }))}
        render={() => { fetchEnvironmentsData(); }}
        pageSize={20}
        setIsLoad={(bool) => setState({ isLoading: bool })}
      />
    );
  }

  function tableRoomTypes() {
    if (state.roomTypes.length === 0) {
      return <div>{`(${t('nenhum')})`}</div>;
    }

    return (
      <TableRoomTypes
        roomTypes={state.roomTypes}
        onDeleteClick={deleteRoomType}
        onEditClick={openCreateEditRoomType}
      />
    );
  }

  return (
    <>
      <SubTabs
        tabs={[t('ambientes'), t('tiposDeAmbientes')]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === t('ambientes') && (
        tableEnvironments()
      )}
      {activeTab === t('tiposDeAmbientes') && (
        <>
          {profile.manageAllClients && (
            <>
              <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditRoomType()}>{t('adicionarTipoDeAmbiente')}</SimpleButton>
              <Link to={`/painel/adicionar-lote/tipos-ambiente?idcliente=${clientId}`}>
                <SimpleButton style={{ fontSize: '80%' }} variant="primary">{t('cadastroEmMassaTipoAmbientes')}</SimpleButton>
              </Link>
            </>
          )}
          {tableRoomTypes()}
        </>
      )}
    </>
  );
};
